// Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
export const ADMIN_PASSWORD_PATTERN = new RegExp(
	// /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`!@#$%^&*()\-_=+{};:,<.>]).{8,}$/
	/^(?=.*[A-Za-z])(?=.*\d)[\S\s]{8,}$/
);

export const APP_USER_PASSWORD_REQUIREMENT_REG_EXP = new RegExp(
	/^(?=.*[A-Za-z])(?=.*\d)[\S\s]{8,}$/ // 密碼長度至少八個字元或以上，需包括英文字母及數字
);
export const APP_USER_PASSWORD_RESTRICT_REG_EXP = new RegExp(
	/^[a-zA-Z0-9@$!%?:&-_+=]*$/ //密碼只容許輸入英文字母、數字或符號@$!%?:&-_+=
);

export const VERIFICATION_CODE_PATTERN = new RegExp(/^\d{4}$/);

export const NONE_INVALID_DATE_PATTERN = new RegExp(/^((?!Invalid Date).)*$/);
